import React from "react";
import { MailBuilder } from "mail-builder-package";
import { inject } from "mobx-react";
import TemplatesStore from "../../../stores/templatesStore";
//import ViewStore from "../../stores/ViewStore";
import { observable, action } from "mobx";
import { TemplateModel } from "../../../stores/TemplateModel";
import { observer } from "mobx-react";
import { notification } from "antd";
import { withRouter, RouteComponentProps } from "react-router-dom";
import UserStore from "../../../stores/UserStore";

interface Props extends RouteComponentProps<any> {
  templatesStore?: TemplatesStore;
  userStore?: UserStore;
}

@inject("userStore")
@observer
class CreateTemplatePage extends React.Component<Props, any> {
  @observable template: TemplateModel = this.props.templatesStore!.create();
  @observable isLoading: boolean = false;

  constructor(props: any) {
    super(props);
    this.template = this.props.templatesStore!.create();
  }

  displaySuccessSaveNotification = () => {
    notification["success"]({
      message: "Save template successful",
      description: ""
    });
  };

  @action onSave = async (json: any, html: string, templateDataUrl: any) => {
    this.template!.json = json;
    this.template!.html = html;
    this.template!.templateDataUrl = templateDataUrl;
    this.isLoading = true;

    const response: any = await this.template!.save();
    const { status, data } = response;

    this.isLoading = false;
    if (status !== 200) {
      return;
    }
    this.template.updateFromJson(data.template);
    this.displaySuccessSaveNotification();
  };

  render() {
    if(this.props.userStore?.needToUpgrade){
      this.props.history.push(`/templates`);
    }
    return (
      <MailBuilder
        template={this.template.json}
        onSave={this.onSave}
        isLoading={this.isLoading}
        closeEditor={() => this.props.history.push("/templates")}
      />
    );
  }
}

export default inject("templatesStore")(withRouter(CreateTemplatePage));
